/* BSRATE-TRANS-002 — cle de transition pour l'outlet racine (ProtectedLayout).
 *
 * Fige /results/* sur une seule cle : ResultsLayout possede son propre crossfade
 * interne (AnimatedOutlet) + sa FilterBar persistante, il doit donc rester monte
 * pendant que ses routes enfants changent (sinon double animation + remount de la
 * FilterBar). Toutes les autres sections s'animent par pathname complet, ce qui
 * anime aussi les changements de page a l'interieur d'une meme section. */
export function getSectionKey(pathname) {
  if (pathname.startsWith('/results')) return 'results';
  return pathname;
}
